import { Flex } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useModalState } from '~/atoms/ModalState'
import { Checkbox } from '~/components/shared/Checkbox'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import useCloudwatchLogger from '~/hooks/useCloudwatchLogger'
import { Size } from '~/types/ThemeTypes'

const FeedbackReasonsModal = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])
  const {
    feedbackModal: [feedbackModalState, setFeedbackModalState],
  } = useModalState()
  const { logger } = useCloudwatchLogger('FeedbackReasonsModal')

  const reasons = [
    { name: 'Sound was delayed', value: 'call_fb_sound_delayed' },
    { name: "I couldn't hear others", value: 'call_fb_couldnt_hear_others' },
    { name: 'There was echo', value: 'call_fb_echo' },
    { name: 'Audio was breaking up', value: 'call_fb_audio_breaking_up' },
    {
      name: "Others couldn't hear me",
      value: 'call_fb_others_couldnt_hear_me',
    },
    { name: 'Other audio issue', value: 'call_fb_other_audio_issue' },
  ]

  const handleSubmitFeedback = () => {
    for (const reason of selectedOptions) {
      logger?.info(reason)
    }
    handleCloseModal()
  }

  const handleCloseModal = () => {
    setFeedbackModalState({ open: false })
    setSelectedOptions([])
  }

  const handleDismissModal = () => {
    logger?.info('call_fb_dismiss')
    handleCloseModal()
  }

  return (
    <MangoModal
      size={Size.sm}
      isOpen={feedbackModalState.open}
      header={'What went wrong?'}
      footer={
        <Flex justifyContent={'flex-end'} gap={'2'}>
          <MangoButton
            onClick={handleDismissModal}
            variant={MangoButtonVariant.Default_100}
          >
            Dismiss
          </MangoButton>
          <MangoButton onClick={handleSubmitFeedback}>
            Submit Feedback
          </MangoButton>
        </Flex>
      }
      onClose={handleDismissModal}
    >
      <Flex direction={'column'}>
        {reasons.map((reason) => (
          <Flex key={reason.value}>
            <Checkbox
              key={reason.value}
              label={reason.name}
              defaultChecked={selectedOptions.includes(reason.value)}
              onChange={(checked) => {
                if (checked) {
                  setSelectedOptions([...selectedOptions, reason.value])
                } else {
                  setSelectedOptions(
                    selectedOptions.filter((option) => option !== reason.value),
                  )
                }
              }}
            >
              {reason.name}
            </Checkbox>
          </Flex>
        ))}
      </Flex>
    </MangoModal>
  )
}

export default FeedbackReasonsModal
